(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-legal-guarantee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eu-guarantee-notice')) {
    customElements.define('eu-guarantee-notice', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const trigger = this.querySelector('.eu-guarantee-trigger');
        const dialog = this.querySelector('dialog');
        trigger.addEventListener('click', () => dialog.showModal());
        this.querySelector('.eu-guarantee-close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => trigger.focus());
      }
      disconnectedCallback() {
        const dialog = this.querySelector('dialog');
        if (dialog && dialog.open) dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
